import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const BitLabs = ()=> {

  const apikey      = '094c4132-ecb7-476e-a4b3-9442797f17c0';
  const currentUser = security.currentUserValue;

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" showLogo={true} />
      <iframe
        width="100%"
        frameBorder="0"
        style={{height: "92vh"}}
        src={`https://web.bitlabs.ai/?uid=${currentUser.id}&token=${apikey}`}
      ></iframe>
    </Fragment>
  );
};

export default BitLabs;
